export enum AchCustomerStatus {
  Verified = "verified",
  Pending = "pending",
  Document = "document",
  DocumentInReview = "document-in-review",
  Review = "review",
  Retry = "retry",
  Suspended = "suspended"
}

export enum AchCustomerType {
  Org = "business",
  Payee = "receive-only",
  Vendor = "unverified"
}

//Over loaded Enum for AchCustomerType, since AchCustomerType uses json values which are sent to dwolla such as business, receive-only
export enum AchCustomerSearchType {
  Org = "ORG",
  Payee = "PAYEE",
  Vendor = "VENDOR"
}

export class AchCustomer {
  id?: number;
  version?: number;
  customerId?: string;
  customerType: AchCustomerType;
  status: AchCustomerStatus;
  canSendFunds: boolean;
  requireCertification: boolean;
}

export class DwollaCustomer {

  firstName: string;
  lastName: string;
  email: string;
  status: AchCustomerStatus;
}
